import Text from 'components/ui/Text';

type InvoiceNumberCellProps = {
    invoiceNumber?: string | null;
    canEdit?: boolean;
};

const InvoiceNumberCell = ({ invoiceNumber, canEdit }: InvoiceNumberCellProps) => {
    return (
        <Text fontSize={13} color={canEdit ? 'text' : 'textDisabled'}>
            {invoiceNumber}
        </Text>
    );
};

export default InvoiceNumberCell;
